import styled from 'styled-components'

const ContactUsStyle = styled.div.attrs()`

    section {
        max-width: var(--sp152x);
        margin:var(--sp5x) auto var(--sp10x);

        .ant-form {
            width: var(--sp118x);
            background-color: var(--white);
            border-radius:30px;
            position: relative;
            padding:var(--sp4x) var(--sp5x) var(--sp5x) var(--sp5x);
            margin:var(--sp12x) 0;

            
            & > .radio {
                margin-bottom:0;
            }

            @media screen and (max-width:1700px){
                margin-top:var(--sp36x);
            }

            @media screen and (max-width:1200px){
                margin-top:var(--sp50x);
            }

            @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
                width: calc(100% - var(--sp16x));
            }
            .op-close {
                position: absolute;
                top: var(--sp5x);
                right: var(--sp5x);
            }

            .title {
                margin-bottom:var(--sp5x);
            }

            button {
                align-self:flex-end;
            }

            .thank-you {
                padding:var(--sp16x) 0 var(--sp15x);

                .sub {
                    margin:var(--sp4x) 0 var(--sp6x);
                }

                button {
                    align-self:center;
                }
            }
        }

        .top {
            align-items: center;
            
            .left {
                flex:1;
                align-items: flex-start;

                .sub {
                    margin:var(--sp3x) 0 var(--sp6x);
                }
            }

            .imageCont {
                width: 39%;
                padding-top: 39%;
            }
        }

        .middle {
            margin:var(--sp15x) 0;

            & > .NewYork {
                max-width: var(--sp60x);
            }

            .block {
                margin-top:var(--sp8x);


                .single-block {
                    border-radius: 20px;
                    padding:var(--sp5x);
                    border:1px solid var(--lightGrey);
                    width: calc(50% - var(--sp2x));

                    .title {
                        margin-bottom: var(--sp2x);
                    }

                    a {
                        color:var(--purple);
                    }
                }
            }
        }

        .bottom {
            position: relative;
            border-radius: 30px;
            overflow: hidden;

            .popup {
                position: absolute;
                top:50%;
                left:0;
                transform: translateY(-50%);
                z-index: 3;
                background-color: var(--white);
                border-radius:30px;
                width: var(--sp51x);
                padding:6.7% 6.7% 6.7% 0;

                .address {
                    margin:var(--sp6x) 0;
                    max-width: var(--sp30x);
                }
            }

            .imageCont {
                width: 100%;
                padding-top:46%;
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        section {
            max-width: var(--sp152x);
            margin:var(--sp5x) auto var(--sp10x);

            .parent-cont {
                & > div {
                    width: 100%;
                }
            }

            .ant-form {
                margin-left:auto;
                margin-right:auto;
                padding:var(--sp2-5x) ;
                margin-top: var(--sp12x);

                .op-close {
                    top: var(--sp3x);
                    right: var(--sp2-5x);
                }

                .title {
                    margin-bottom:var(--sp3x);
                }
            }
            
            .top {
                align-items: center;
                flex-direction: column;

                .left {
                    flex:1;
                    align-items: flex-start;

                    .sub {
                        margin:var(--sp3x) 0 var(--sp6x);
                    }
                }

                .imageCont {
                    width: 60%;
                    padding-top: 60%;
                    margin-left: auto;
                }
            }

            .middle {
                margin:var(--sp15x) 0;

                & > .NewYork {
                    max-width: var(--sp60x);
                }

                .block {
                    margin-top:var(--sp8x);
                    flex-direction: column;

                    .single-block {
                        border-radius: 20px;
                        padding:var(--sp5x);
                        border:1px solid var(--lightGrey);
                        width: 100%;

                        &:not(:first-child){
                            margin-top:var(--sp3x);
                        }

                        .title {
                            margin-bottom: var(--sp2x);
                        }

                        a {
                            color:var(--purple);
                        }
                    }
                }
            }

            .bottom {
                position: relative;
                border-radius: 30px;
                overflow: hidden;

                .popup {
                    position: absolute;
                    top:50%;
                    left:0;
                    transform: translateY(-50%);
                    z-index: 3;
                    background-color: var(--white);
                    border-radius:30px;
                    width: var(--sp51x);
                    padding:6.7% 6.7% 6.7% 0;

                    .address {
                        margin:var(--sp6x) 0;
                        max-width: var(--sp30x);
                    }
                }

                .imageCont {
                    width: 100%;
                    padding-top:70%;
                }
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.MobileSize}){
        section {
            max-width: unset;
            margin:var(--sp3x) auto var(--sp4x);

            button {
                padding:var(--sp2x) var(--sp3x);
            }

            .ant-form {
                width: calc(100% - var(--sp4x));
                padding:var(--sp2-5x) ;
                margin-top: var(--sp40x);

                &.thank-you {
                    margin-top: unset;
                    margin-bottom: unset;
                }

                .op-close {
                    top: var(--sp3x);
                    right: var(--sp2-5x);
                }

                .title {
                    margin-bottom:var(--sp3x);
                }

                .ant-form-item {
                    flex-direction: column;

                    & > * {
                        flex:unset;
                    }
                }
                
                .halfInputs {
                    .ant-form-item {
                        flex-direction: column;

                        & > * {
                            flex:unset;
                        }
                    }
                }
                
                .thank-you {
                    padding:var(--sp8x) 0;

                    .sub {
                        margin:var(--sp2x) 0 var(--sp4x);
                        max-width: var(--sp30x);
                        text-align: center;
                    }

                    button {
                        align-self:center;
                    }
                }
            }
            

            .top {
                align-items: center;
                flex-direction: column;

                .left {
                    flex:1;
                    align-items: flex-start;

                    .sub {
                        margin:var(--sp3x) 0 var(--sp5x);
                    }
                }

                .imageCont {
                    width: 60%;
                    padding-top: 60%;
                    margin-left: auto;
                    margin-top: -24px;
                }
            }

            .middle {
                margin:var(--sp7x) 0 var(--sp10x);

                & > .NewYork {
                    max-width: unset;
                }

                .block {
                    margin-top:var(--sp3x);
                    flex-direction: column;

                    .single-block {
                        border-radius: 20px;
                        padding:var(--sp3x);
                        width: 100%;

                        &:not(:first-child){
                            margin-top:var(--sp2x);
                        }

                        .title {
                            margin-bottom: var(--sp1-5x);
                        }

                        a {
                            color:var(--purple);
                        }
                    }
                }
            }

            .bottom {
                position: relative;
                border-radius: 30px;
                overflow: hidden;

                .popup {
                    position: absolute;
                    top:var(--sp5x);
                    transform: translateY(0);
                    width: var(--sp27x);
                    padding:var(--sp5x) var(--sp5x) var(--sp5x) 0;

                    .address {
                        margin:var(--sp4x) 0;
                        max-width: unset;
                    }
                }

                .imageCont {
                    width: 100%;
                    padding-top:186%;
                }
            }
        }
    }
`

export default ContactUsStyle
